export const ABN = '78 003 191 035';
export const AFSL = '239545';

export const LINKEDIN_URL = 'https://www.linkedin.com/company/qbe';
export const FACEBOOK_URL = 'https://www.facebook.com/QBEInsuranceAustralia/';
export const YOUTUBE_URL = 'https://youtube.com/c/qbeinsurance';
export const X_URL = 'https://x.com/qbe';
export const INSTAGRAM_URL = 'https://instagram.com/qbeaus';
